import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AccessControl from '../../AccessControl';
import { MODULES_KEY, PERMISSION_OBJECT, ROUTES } from '../../common/constants';
import ResourceAllocationV2 from './ResourceAllocationV2';
import ResourceAllocationV3 from './ResourceAllocationV3';

const ResourceAllocationWrapperV2 = () => (
  <Switch>
    <Route
      exact
      path={ROUTES?.RESOURCE_ALLOCATION}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.RESOURCE_ALLOCATION}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <ResourceAllocationV2 {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={ROUTES?.RESOURCE_ALLOCATION_v3}
      render={(props) => (
        <AccessControl
          modulekey={MODULES_KEY?.RESOURCE_ALLOCATION}
          allowedPermissions={[PERMISSION_OBJECT?.read]}
          showNoAccess
        >
          <ResourceAllocationV3 {...props} />
        </AccessControl>
      )}
    />
  </Switch>
);
export default ResourceAllocationWrapperV2;
